module.exports = __webpack_public_path__ + "6229cf5706a7d6c5f45d67f2afb93d74.pdf";